import { type ComponentProps } from 'react';
import { classes } from '@/util/component-utils';
import styles from './Chip.module.css';

export type ChipSize = "small" | "default";

export interface ChipProps extends ComponentProps<'span'> {
    label: string;
    size?: ChipSize;
    color?: "default" | "error" | "warning" | "success" | "primary" | "secondary";
    className?: string;
}

const colorClass = (color?: string) => {
    switch (color) {
        case "error":
            return styles.error;
        case "warning":
            return styles.warning;
        case "success":
            return styles.success;
        case "primary":
            return styles.primary;
        case "secondary":
            return styles.secondary;
        default:
            return "";
    }
}

export default function Chip(props: ChipProps) {
    let sizeClass;
    if (props.size && props.size === "small") {
        sizeClass = styles.small;
    }

    return <span className={classes(styles.chip, colorClass(props.color), sizeClass, props.className)}>{props.label}</span>;
}
